import { NewMembershipTerm } from '@/components/admin/membership/users/NewMembershipTerm';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(
  NewMembershipTerm,
  { requiresEvery: [RouteRestrictions.ADMIN_ROLE] },
  { requiresMemberManagement: true }
);
